export default "__VITE_ASSET__wxYvXkVY__"